import { useSelector } from 'react-redux';

type AuthSlice = {
  auth: { user?: { is_student?: boolean } };
};

/**
 * O usuário logado é aluno (`is_student` do `/me`)?
 *
 * Diferente do `useIsAcademyUser`, não depende de plano nem de flag: é o dado
 * cru do cadastro. `isLoading` fica `true` enquanto o `/me` não chegou, para
 * quem decide redirect não agir antes de saber.
 */
export function useIsStudentUser(): { isStudent: boolean; isLoading: boolean } {
  const user = useSelector((state: AuthSlice) => state.auth?.user);

  return { isStudent: user?.is_student === true, isLoading: !user };
}

export default useIsStudentUser;
